import { ref } from 'vue';
import zhCN from '@/locales/zh-CN.json';

export type UiLanguage = 'zh-CN' | 'en-US';

const language = ref<UiLanguage>('zh-CN');
const messages: Record<string, string> = zhCN;

export const languageOptions = [
  { label: '简体中文', value: 'zh-CN' as const },
  { label: 'English', value: 'en-US' as const },
];

/** Shared with the persisted settings store so labels update without reloading. */
export function useUiLanguage() {
  return language;
}

/** English source messages also provide a fallback for new or external content. */
export function t(source: string, params: Record<string, unknown> = {}): string {
  const message = language.value === 'en-US' ? source : (messages[source] ?? source);
  return message.replace(/\{(\w+)\}/g, (placeholder, key: string) =>
    Object.hasOwn(params, key) ? String(params[key]) : placeholder,
  );
}
